import * as React from 'react';
import { SVGProps } from 'react';

const SvgShareFilled = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      d="m12.2 3.05.058.002.931.931h-2.856A4.483 4.483 0 0 0 5.85 8.467v1.866a.75.75 0 0 0 1.5 0V8.467a2.983 2.983 0 0 1 2.983-2.984h2.856l-2.452 2.454a.75.75 0 1 0 1.06 1.06l2.086-2.088v7.158c0 .93-.754 1.683-1.683 1.683H1.933c-.93 0-1.683-.754-1.683-1.683V4.733c0-.881.677-1.603 1.538-1.677l.145-.006H12.2Z"
      fill="currentColor"
    />
    <path
      d="m11.796.47 3.734 3.733a.75.75 0 0 1 0 1.06L13.883 6.91V4.733c0-.88-.676-1.603-1.538-1.677l-.087-.004-1.522-1.522a.75.75 0 0 1 1.06-1.06Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgShareFilled;
